module.exports = __webpack_public_path__ + "static/media/link.68b36eac.png";